import { render, staticRenderFns } from "./ProductCardItem.vue?vue&type=template&id=6ae1a5c6&scoped=true&"
import script from "./ProductCardItem.vue?vue&type=script&lang=js&"
export * from "./ProductCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardItem.vue?vue&type=style&index=0&id=6ae1a5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1a5c6",
  null
  
)

export default component.exports